<template>
  <div>
    <input
      @change="$emit('update:modelValue', isChecked)"
      type="checkbox"
      :id="fieldId"
      class="mr-2 hidden"
      v-model="isChecked"
    />
    <label
      :for="fieldId"
      class="flex flex-row items-center cursor-pointer select-none"
      :class="[`text-${color} hover:font-bold`, isChecked ? 'font-bold' : '']"
    >
      <div
        v-show="isChecked"
        class="mr-2 bg-white"
        :class="[
          rounded ? 'rounded-full' : 'rounded-sm',
          'border',
          `border-${color}`,
        ]"
        style="width: 18px; height: 18px; padding: 2px 2px;"
      >
        <div
          style="width: 12px; height: 12px;"
          :class="[rounded ? 'rounded-full' : 'rounded-sm', `bg-${color}`]"
        ></div>
      </div>
      <div
        v-show="!isChecked"
        class="mr-2 bg-white"
        :class="[
          rounded ? 'rounded-full' : 'rounded-sm',
          'border',
          `border-${color}`,
        ]"
        style="width: 18px; height: 18px;"
      ></div>
      {{ explanation }}
    </label>
  </div>
</template>
<script>
import { ref } from '@vue/reactivity'

export default {
  name: 'AppCheckbox',
  emits: ['update:modelValue'],
  props: {
    explanation: {
      type: String,
      required: true,
    },
    fieldId: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      default: '',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const isChecked = ref(props.modelValue)
    return {
      isChecked,
    }
  },
}
</script>
